import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";

import { createWidget, toggleHotspotView } from "actions/editor";

import _ from 'lodash';
import cx from 'classnames';
import { Frame } from "scenejs";
import shortid from 'shortid';

import { Button } from 'react-bootstrap';

import { Property } from '../../components/properties/';
import { getBoundingRectFromLayout } from 'components/Editor/helper/layoutManager';
import { EditorContext } from "components/Editor";
import { useAllowCreateLiveElement, useWidgetChildrenSelector } from "components/Editor/hooks/useEditorSession";

import { HOTSPOT_WIDGET_REQUEST } from 'constants/hotspot';
import { HOTSPOT } from "constants/widgetTypes";

import styles from './hotspot.module.scss';

export const HotspotActionButton = ({ onClick, widget }) => {
  const dispatch = useDispatch();

  const editorContext = useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;
  const entityType = useSelector(state => _.get(state, `${editorSession}.present.entityType`));

  const widgets = useWidgetChildrenSelector(editorSession, widget.uid);
  const hotspotWidget = widgets[0];

  const handleClick = () => {
    if (hotspotWidget) {
      dispatch(toggleHotspotView(editorSession, hotspotWidget.uid));
      return;
    }
    
    onClick('hotspot');
  }
  
  return (
    <>
    {entityType !== 'LIVE_ELEMENT' &&
     <Property.Action className={cx(styles.iconButton, { [styles.hotspotEnabled]: hotspotWidget })} tooltip='Hotspot' onClick={handleClick}>
       <i className={'cleverstory-plus'} />
     </Property.Action>
    }
    </>
  )
}

export const HotspotCreationProperty = ({ widget, onCancel }) => {
  const dispatch = useDispatch();

  const editorContext = useContext(EditorContext);
  const editorSession = editorContext.editorSession.id;

  const handleMarkHotspot = () => {
    var parent = widget.uid;
    var uid = `widget_${shortid.generate()}`;

    var hotspotWidget = HOTSPOT_WIDGET_REQUEST.find(item => item.type === HOTSPOT);

    const _getChildLayout = (parent, hotspot, breakpoint) => {
      const parentLayout = _.get(parent, `properties.${breakpoint}.layout`);
      const parentRect = getBoundingRectFromLayout(parentLayout);

      const childLayout = _.get(hotspot, `properties.${breakpoint}.layout`);
      const childRect = getBoundingRectFromLayout(childLayout);

      var newX = 0;
      var newY = 0;

      var xdiff = 1200 - (parentRect.x + parentRect.width);

      if (xdiff > (childRect.width + 20)) {
        newX = parentRect.width + 20;
      } else if (xdiff < childRect.width) {
        newX = (childRect.width * -1) - 20;
      } 

      const frame = new Frame(childLayout);
      frame.set('transform', 'translate', `${newX}px, ${newY}px`);

      return frame.get();
    }

    const desktopLayout = _getChildLayout(widget, hotspotWidget, 'desktop');
    const mobileLayout = _getChildLayout(widget, hotspotWidget, 'mobile');

    var childWidgets = HOTSPOT_WIDGET_REQUEST.filter(item => item.type !== HOTSPOT)
      .map(item => {
        return {
          ...item,
          uid: `widget_${shortid.generate()}`,
          parent: uid
        }
      });

    hotspotWidget = {
      ...hotspotWidget,
      uid: uid,
      parent: parent,
      order: 1,
      properties: {
        ...hotspotWidget.properties,
        desktop: {
          ...hotspotWidget.properties.desktop,
          layout: desktopLayout
        },
        mobile: {
          ...hotspotWidget.properties.mobile,
          layout: mobileLayout
        }
      }, 
      widgets: childWidgets
    }

    dispatch(createWidget(editorSession, [hotspotWidget], widget.uid));
    dispatch(toggleHotspotView(editorSession, hotspotWidget.uid));
  }

  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
  }

  return (
    <Property.Dialog className={styles.styleDialog}
      width={233}
      target={`#${widget.uid}`}
      title={'Mark as Hotspot:'}
      onCancel={handleClose}
    >
      <Property.Body>
        <div className={styles.container}>
          <p>A Hotspot is an element that you can reuse in a storyboard. </p>

          <p>Are you sure you want to continue?</p>
          <div className={styles.actions}>
            <Button
              size='sm'
              className={styles.action}
              variant='secondary'
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              onClick={handleMarkHotspot}
              size='sm'
              className={styles.action}
              variant='primary'
            >
              {`Confirm`}
            </Button>
          </div>
        </div>
      </Property.Body>
    </Property.Dialog>
  )
}